module.exports = __webpack_public_path__ + "img/CSLogo.e6527b8e.png";